<div class="row my-3">
  <div class="d-flex justify-content-around">
    <div class="sort  d-flex align-items-center">
      <select name="" id="" class="form-select me-2" [(ngModel)]="sortSelect" (change)="onSortChange()">
        <option value="age">Age</option>
        <option value="size">Size</option>
        <option value="gender">Gender</option>
      </select>
      <i class="fa fa-sort fs-5 me-2 mb-2 mt-2" aria-hidden="true"></i>
    </div>
    <div class="search d-flex align-items-center justify-content-end">
      <input (ngModelChange)="onDogSearch()" type="text" class="form-control w-75 me-2" placeholder="Search by breed..." [(ngModel)]="searchQ">
      <div (click)="onDogSearch()" class=""><i class="fa fa-search fs-5 me-2 mb-2 mt-2" aria-hidden="true"></i></div>
    </div>
  </div>
</div>